export interface FlagsmithProviderProps {
  envID: string;
  hasIdentify: boolean;
  hasCompanyTraits?: boolean;
  injectDatadogRum?: boolean;
  options?: Record<string, unknown>;
}

export const FlagsmithProviders = {
  '@mint/arm': {
    envID: import.meta.env.VITE_ARM_FF,
    hasIdentify: true,
    hasCompanyTraits: true,
    options: {},
  },
  '@mint/app': {
    envID: import.meta.env.VITE_APP_FF,
    hasIdentify: false,
    injectDatadogRum: true,
    options: {},
  },
  '@myn/guest': {
    envID: import.meta.env.VITE_GUEST_FF,
    hasIdentify: false,
  },
  '@myn/secured': {
    envID: import.meta.env.VITE_SECURED_FF,
    hasIdentify: true,
    hasCompanyTraits: true,
  },
  '@myn/notifications': {
    envID: import.meta.env.VITE_NOTIFICATIONS_FF,
    hasIdentify: true,
  },
  '@mint-admin/auth-login': {
    envID: import.meta.env.VITE_AUTH_LOGIN_FF,
    hasIdentify: false,
  },
} as const;
